import { render, staticRenderFns } from "./carCard.vue?vue&type=template&id=2c8a17e8&scoped=true&"
import script from "./carCard.vue?vue&type=script&lang=js&"
export * from "./carCard.vue?vue&type=script&lang=js&"
import style0 from "./carCard.vue?vue&type=style&index=0&id=2c8a17e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a17e8",
  null
  
)

export default component.exports